// extracted by mini-css-extract-plugin
export default {"menuSwitcher":"MenuSwitcher__menuSwitcher-QJtln","collapsed":"MenuSwitcher__collapsed-c6Gwc","icon":"MenuSwitcher__icon-mej_j"};